var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpClient } from "@angular/common/http";
import { ActiveProfileService, IpsBaseWebService } from "imagine-ui-ng-core";
import { environment } from "../../../../environments/environment";
var LocationGroupByLocationService = /** @class */ (function (_super) {
    __extends(LocationGroupByLocationService, _super);
    function LocationGroupByLocationService(http, activeProfileService) {
        var _this = _super.call(this, http, environment, activeProfileService) || this;
        _this.init("LocationGroup", "Profile", "v1");
        // Have to initialize after super() is called.
        _this.route = _this.urlApiBaseProductPlusVersion + "Location/{id}/LocationGroup";
        return _this;
    }
    LocationGroupByLocationService.prototype.getByLocation = function (id) {
        this.LocationId = id;
        return this.getByRoute(this.route.replace("{id}", id));
    };
    LocationGroupByLocationService.prototype.headByLocation = function (id, option) {
        return this.headByRoute(this.route.replace("{id}", id) + "?showUnassignedItems=" + option);
    };
    // Override the ipsBaseWebService.search method.
    LocationGroupByLocationService.prototype.search = function (searchInfo) {
        return this.searchByRelation(searchInfo, "Location/" + searchInfo.id + "/LocationGroupSubGroup/Search");
    };
    return LocationGroupByLocationService;
}(IpsBaseWebService));
export { LocationGroupByLocationService };
